export const makeLoadFailed = <TPromise extends Promise<any>>(): TPromise =>
  Promise.reject(Error('Cache load failed')) as TPromise;
